import React, { useState } from 'react';
import { Form, Button, Alert, Spinner, Col, Row, Tabs,Tab } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { postData, postDataLogin } from '../ApiServices/ApiService';
import NavHeader from './NavHeader';
import ClipboardJS from 'clipboard';
//import { useHistory } from 'react-router-dom';


const CandidateDetails = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const JOBID = searchParams.get('id');
  const examTYPE = searchParams.get('exam_type'); //THEORY,CODING default:THEORY
  // const history = useHistory();
  const [candidate, setCandidate] = useState({
    name: '',
    email: '',
    countryCode: '+1',
    phoneNumber: '',
    jobId: JOBID,
    examTYPE: examTYPE,
    recruiterQuestions: "",
    testSeconds: "60",
    jobDesc: "",
    examLevel: "intermediate",
    jobnumber: ""
  });

  const [validated, setValidated] = useState(false);
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showTextArea, setShowTextArea] = useState(false);
  const [showJobTextArea, setJobTextArea] = useState(false);
  const [aiQuestions, setAiQuestions] = useState("0");
  const [jdQuestions, setJdQuestions] = useState("0");
  const [clientCheckbox, setClientCheckbox] = useState("0");
  const [candidateButtonFlag, setCandidateFlag] = useState(false);
  const [testId, setTestId] = useState('')
  const [sucmsg, setSucMsg] = useState('')
  const [examLink, setExamLink] = useState('')
  const [resume, setResume] = useState('')
  const [resumeext, setResumeExt] = useState('')
  const [resumeFileName, setResumeFileName] = useState('')
  const [fileStatus, setFileStatus] = useState("0")
  const [filePath, setFilePath] = useState('')
  const [showSubmit, setShowSubmit] = useState(false)
  const [resumeLoading, setResumeLoading] = useState(false);
  const [bulkCandidates, setBulkCandidates] = useState([]);
  const [isBulkUpload, setIsBulkUpload] = useState(false);

  const handleCheckBoxChange = (e) => {
    setShowTextArea(e.target.checked);
    candidate.recruiterQuestions = "";
    if (clientQuestionsCheckbox?.checked) {
      setClientCheckbox("1")
    } else {
      setClientCheckbox("0")
    }
  };
  const handleJobCheckBoxChange = (e) => {
    setJobTextArea(e.target.checked);
    candidate.jobDesc = "";
    if (jobDescCheckbox?.checked) {
      setJdQuestions("1")
    } else {
      setJdQuestions("0")
    }

  }
  const handleAiCheckbox = () => {
    // const aiQuestionsCheckbox = document.getElementById('aiQuestionsCheckbox');
    if (aiQuestionsCheckbox?.checked) {
      setAiQuestions("1");
    } else {
      setAiQuestions("0");
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCandidate((prevCandidate) => ({
      ...prevCandidate,
      [name]: value,
    }));
  };

  const numberChange = (event) => {
    const inputValue = event.target.value;
    if (!/[A-Z!@#$%^&*()_+{}[\]:;<>,.?~=/\\-]/.test(inputValue) && !/[a-z]/.test(inputValue)) {
      const { name, value } = event.target;
      setCandidate((prevCandidate) => ({
        ...prevCandidate,
        [name]: value,
      }))

    }
    else {
      // event.preventDefault();

    }
  }

  const aiQuestionsCheckbox = document.getElementById('aiQuestionsCheckbox');
  const clientQuestionsCheckbox = document.getElementById('clientQuestionsCheckbox');
  const jobDescCheckbox = document.getElementById('jobDescCheckbox')
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
    const orgID = localStorage.getItem('org_id');
    setSucMsg('');
    setSuccess('')
    if (form.checkValidity()) {
      if (candidate.phoneNumber.length > 0) {
        if (candidate.phoneNumber.length < 10 || candidate.phoneNumber.length > 10) {
          setSuccess('Please enter 10 digit phone number');
          return;
        }
      }
      // if (candidate.phoneNumber.length == 0) {
      //   setSuccess('Please enter 10 digit phone number');
      //   return
      // }
      if (candidate.jobId == null) {
        setSuccess('select job Id');
        return
      }

      if (activeTab === 'add-bulk-candidates' && (!bulkCandidates || bulkCandidates.length === 0)) {
        setSuccess('Please upload CSV file');
        return;
      }

      setLoading(true);
      //Redirect to tech selector
      const payload = {
        "op": "candidate_signup",
        "candidate_email": candidate.email?.toLowerCase(),
        "candidate_name": candidate.name,
        "user_id": aminInfo?.user_id,
        "job_id": candidate.jobId,
        "exam_type": examTYPE,
        "candidate_phone_no": candidate.phoneNumber,
        "candidate_country_code": candidate.countryCode,
        "resume_data":resume,
        "resume_ext":resumeext,
        "file_name":resumeFileName,
        "resume_file_status":fileStatus,
        "resume_file_path":filePath,
        "bulk_data":bulkCandidates,
        "bulk": isBulkUpload ? 1 : 0,
      }
      console.log("candidate signup payload",payload );
      // return
      try {
        postData('admin_in/candidate-interview/add-candidate-details', payload).then(resp => {
          resp.json().then(respData => {
            if (resp.status === 200) {
              if (respData.statusCode === 200) {
                if (respData.message.toLowerCase() === 'success') {
                  setLoading(false);
                  setSucMsg(respData.info);
                  setCandidateFlag(true)
                  setButtonText('Copy Link')
                  setTestId(respData.dataJ.test_id)
                  setExamLink(respData.dataJ?.exam_link);
                  if (candidate.jobId !== "") {
                    localStorage.setItem("jobId", candidate.jobId)
                  }

                  setCandidate({
                    name: '',
                    email: '',
                    countryCode: '+1',
                    phoneNumber: '',
                    jobId:candidate.jobId,
                    examLevel: 'intermediate'
                  });
                  setResume('');
                  setResumeExt('');
                  setResumeFileName('');
                  // setFileStatus('');
                  setFilePath('');
                  setFileStatus("0");
                  setFileName('');
                  setBulkCandidates([]);
                  // if(resp.dataJ.ai_question_type === "1"){
                  //   navigate(`/techselect?id=${resp.dataJ.candidate_id}`,{state: { testId:resp.dataJ.test_id }});
                  // }else{
                  //   navigate(`/link-generator?id=${resp.dataJ.test_id}`);
                  // }

                } else {
                  setLoading(false);
                  setSuccess(respData.info);
                }

              } else if (respData.statusCode === 500) {
                setLoading(false);
                setSuccess(respData.info);
              } else {
                setLoading(false);
                setSuccess('Login failed. Please check your credentials.');
              }
            } else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
              console.log('resp status else if : ', resp.status);
              setLoading(false)
              if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                || respData.message === 'Access Denied') {
                setLoading(false);
                //   callRefreshTokenApi('getSfeBatch', '');
              }
              setSuccess('Looks Like Session Expired Please login..');
            } else {
              console.log('resp status else  : ', resp);
              setLoading(false);
            }
          }).catch((error) => {
            setSuccess('Network Error');
            console.log('network error:', error);
            setLoading(false);
          });
        }).catch((error) => {
          setLoading(false);
          setSuccess('Login failed. Please check your credentials or Network Error');
          console.log('network error:', error);

        });
      } catch (error) {
        setLoading(false);
        // Handle login error, e.g., display an error message to the user.
        console.error('Login failed', error);
      }

    } else {
      setValidated(true);
    }
  };

  // const [selectedFile, setSelectedFile] = useState(null);
  // const [previewURL, setPreviewURL] = useState(null);

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   setSelectedFile(file);

  //   const reader = new FileReader();
  //   reader.onloadend = () => {
  //     setPreviewURL(reader.result);
  //   };
  //   if (file) {
  //     reader.readAsDataURL(file);
  //   }
  // };
  const clickCandidatePage = () => {
    navigate(`/candidate-info?id=${testId}`)
  }

  const [buttonText, setButtonText] = useState(' Copy Link');

  const handleCopy = () => {
    const clipboard = new ClipboardJS('.copy-button', {
      text: function () {
        return examLink;
      },
    });

    clipboard.on('success', () => {
      setButtonText(' Copied')
      clipboard.destroy();
    });

    clipboard.on('error', () => {
      alert('Failed to copy link to clipboard!');
      clipboard.destroy();
    });
  };

  const handleFileUploadChange = async (event) => {
    const file = event.target.files[0];
    console.log("file", file)
    if (file) {
      try {
        await uploadResume(file);
        event.target.value = '';
      } catch (error) {
        console.error('Error uploading resume:', error);
      }
    }
  };

//   const handleImageUpload = (event) => {
    
// };

  // const uploadResume = async (file) => {
  //   setLoading(true);
  //   setSucMsg('');
  //   const payload = {
  //     "op":"resumeUpload",
  //     "file_name": file.name
      
  //   };
  
  //   try {
  //     const resp = await postData('admin_in/upload-resume', payload);
  //     const respData = await resp.json();
  
  //     if (resp.status === 200 && respData.statusCode === 200 && respData.message.toLowerCase() === 'success') {
  //       console.log("came to if");
  //       const url = respData.dataJ[0].url;
        

  //       const formData = new FormData();
  //       formData.append('key', respData.dataJ[0].fields.key);
  //       formData.append('x-amz-security-token', respData.dataJ[0].fields['x-amz-security-token']);
  //       formData.append('x-amz-signature', respData.dataJ[0].fields['x-amz-signature']);
  //       formData.append('policy', respData.dataJ[0].fields.policy);
  //       formData.append('x-amz-algorithm', respData.dataJ[0].fields['x-amz-algorithm']);
  //       formData.append('x-amz-credential', respData.dataJ[0].fields['x-amz-credential']);
  //       formData.append('x-amz-date', respData.dataJ[0].fields['x-amz-date']);
  //       formData.append('file', file);
        
  //       const presignedResp = await fetch(url, {
  //         method: 'POST',
  //         body: formData,
  //         headers: {
  //           // 'Content-Type': 'multipart/form-data',
  //         },
  //       });
  
  //       if (presignedResp.status === 204) {
  //         setSucMsg("File Uploaded Successfully");
  //         setLoading(false);
          
  //       } else {
  //         setLoading(false);

  //         // console.log("Presigned URL request failed:", presignedResp.status);
  //       }
  //     } else {
  //       console.log("came to else");
  //       if (resp.status === 500 && respData.statusCode === 500 ) {
  //         setLoading(false);
  //         setSuccess(resp.info);
  //       }else{
  //         setLoading(false);
  //         setSuccess(resp.info);
  //       }
        
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     setSuccess("Failed To Upload File");
  //     console.error('Error:', error);
      
  //   }
  // }

  const uploadResume = async (event) => {
    setSucMsg('');
    setSuccess('');
    setResumeLoading(true);
    const file = event.target.files[0];

    if (!file) {
      setResumeLoading(false);
      console.log('No file selected');
      return;
  }

    // const fileSize = file.size; // Size of the file in bytes
    // console.log("File size:", fileSize, "bytes");
    // if (fileSize > 100 * 1024) {
    //     setSuccess("Max File Allowed 100 KB.");
    //     setFileStatus("0"); // Set file status to 1 (failed)
    //     return false;
    // }

    const fileSize = file.size; // Size of the file in bytes
    console.log("File size:", fileSize, "bytes");
    if (fileSize > 5 * 1024 * 1024) { // 5MB in bytes
        setSuccess("Max File Allowed 5 MB.");
        setResumeLoading(false);
        setFileStatus("0"); // Set file status to 1 (failed)
        return false;
    }

    const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
    const timestamp = new Date().getTime(); // Get current timestamp
    const uniqueId = `${randomSixDigitNumber}.${timestamp}`;; // Create a unique ID
    const fileName = `${uniqueId}.${file.name.split('.').pop()}`;
    const fileNameWithoutExtension = `${uniqueId}`; // Add the unique ID to the file name
    setResumeFileName(fileNameWithoutExtension);

    const fileExtension = fileName.split('.').pop().toLowerCase();
    console.log("File extension:", fileExtension);
    setResumeExt(fileExtension);
    const allowedExtensions = ['pdf', 'doc', 'docx']
    if (!allowedExtensions.includes(fileExtension)) {
        setSuccess("Only Valid Images are allowed pdf,doc,docx,");
        setResumeLoading(false);
        setFileStatus("0"); // Set file status to 1 (failed)
        return false;
    }

    if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64Image = reader.result.split(',')[1];
            console.log("base64Image", base64Image);
            setResume(base64Image);
            console.log("resume", resume);
            setFileStatus("1"); // Set file status to 0 (success)

            const fileNameWithoutExtension = fileName.replace(/\.[^/.]+$/, ""); // Removes the extension
            console.log(fileNameWithoutExtension);

            const payload = {
                "resume_data": base64Image,
                "resume_ext": fileExtension,
                "file_name": fileNameWithoutExtension,
            };

            try {
                postData('admin_in/upload-resume', payload).then(resp => {
                    resp.json().then(respData => {
                        if (resp.status === 200) {
                            if (respData.statusCode === 200) {
                                if (respData.message.toLowerCase() === 'success') {
                                    if (respData.dataJ.length > 0) {
                                        setFilePath(respData.dataJ[0])
                                        setShowSubmit(true);
                                        setLoading(false)
                                        setResumeLoading(false);
                                        setSucMsg("Resume Uploaded Successfully");
                                    } else {
                                        setLoading(false);
                                        setSuccess(resp.info);
                                        setResumeLoading(false);
                                    }
                                } else {
                                    setLoading(false);
                                    setSuccess(resp.info);
                                    setResumeLoading(false);
                                }

                            } else if (respData.statusCode === 500) {
                                setLoading(false);
                                setSuccess(resp.info);
                                setResumeLoading(false);
                            } else {
                                setLoading(false);
                                setSuccess(resp.info);
                                setResumeLoading(false);
                            }
                        }
                        else if (resp.status === 401 || resp.status === 403 || resp.status === 400) {
                            console.log('resp status else if : ', resp.status);
                            setLoading(false)
                            if (respData.message === 'Unauthorized' || respData.message === 'The incoming token has expired'
                                || respData.message === 'Access Denied') {
                                setLoading(false);
                                setResumeLoading(false);
                            }
                        } else {
                            console.log('resp status else  : ', resp);
                            setLoading(false);
                            setResumeLoading(false);
                        }
                    }).catch((error) => {
                        console.log('network error:', error);
                        setLoading(false);
                        setResumeLoading(false);
                    });
                }).catch((error) => {
                    setLoading(false)
                    setLoading(false);
                    setResumeLoading(false);
                    console.log('network error:', error);
                });
            } catch (error) {
                setLoading(false)
                setResumeLoading(false);
                setSuccess('Upload Resume Failed. Please check your credentials or Network Error!');
                console.error('Job Details failed', error);
            }
        };
        reader.readAsDataURL(file);
    } else {
        console.log('No file selected');
        setFileStatus("0"); // Set file status to 1 (failed)
    }
};

const handleBulkUpload = (event) => {
  setSucMsg('');
  setSuccess('');
  const file = event.target.files[0];
  event.target.value = '';

  if (file) {
      try {
          const reader = new FileReader();
          setFileName(file.name);

          reader.onload = (e) => {
              try {
                  const text = e.target.result;
                  const rows = text.split('\n').filter(row => row.trim() !== ''); // Split by line and remove empty lines
                  const headers = rows[0].split(',').map(header => header.trim()); // Get headers from the first row

                  // Ensure the headers match the expected keys
                  const expectedHeaders = [
                      'candidate_name',
                      'candidate_email',
                      'candidate_phone_no',
                      'candidate_country_code',
                  ];

                  const isValidCSV = expectedHeaders.every(header => headers.includes(header));

                  if (!isValidCSV) {
                      setSuccess('CSV file does not match the expected format. Please check the headers.');
                      return;
                  }

                  const candidates = rows.slice(1).map(row => {
                      const values = row.split(',').map(value => value.trim()); // Split row into values
                      const candidate = {};

                      headers.forEach((header, index) => {
                          candidate[header] = values[index]; // Map headers directly to values
                      });

                      return candidate;
                  });

                  // Update bulkCandidates state
                  setBulkCandidates(candidates);

                  // Mark as bulk upload
                  setIsBulkUpload(true);

                  console.log(`Uploaded ${candidates.length} candidates.`);
              } catch (innerError) {
                  console.error('Error parsing CSV file:', innerError);
                  setSuccess('Failed to process CSV file. Please check the file format.');
              }
          };

          reader.onerror = () => {
              setSuccess('Failed to read CSV file. Please check the file format.');
          };

          reader.readAsText(file);
      } catch (error) {
          console.error('Error reading file:', error);
          setSuccess('Unexpected error occurred while reading the CSV file.');
      }
  } else {
      console.log('No file selected. Please upload a valid CSV file.');
  }
};

const [activeTab, setActiveTab] = useState('add-candidate'); // Manage active tab state
const [fileName, setFileName] = useState('');

  const handleTabClick = (tabKey) => {
    setActiveTab(tabKey); // Update active tab on click
  };

  return (
    <div className='dashboard-div'>
      <NavHeader></NavHeader>
      <h3 className='cand-title'>Add Candidate Details</h3>
      <div className='add-job-div'>
        <div className="candidate-div"><div style={{marginBottom:'5px'}}>
          {success && <span style={{ color: 'red', fonSize: '14px', paddingBottom: '10px',marginBottom:'5px' }}>{success}</span>}
          {sucmsg && <span style={{ color: 'green', fonSize: '14px', paddingBottom: '5px',marginBottom:'5px' }}>{sucmsg}</span>}
          {/* {candidateButtonFlag && (

            <Button onClick={clickCandidatePage} className="Button-add" style={{ backgroundColor: 'black', marginLeft: '20px', marginBottom: '10px' }}>Go to Candidate Page</Button>
          )} */}
        </div>
        <Tabs defaultActiveKey="add-candidate" id="candidate-tabs" className="mb-12" onSelect={handleTabClick} style={{   marginBottom:'5px' }}>
      <Tab eventKey="add-candidate"
          title={<span style={{ color: activeTab === 'add-candidate' ? '#007bff' : '#000' }}>Add Candidate</span>} >
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className='screen-styling'>
              <Form.Group controlId="formName" style={{ marginBottom: '10px', marginRight: '0px', width: '100%' }} >
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Name*"
                  value={candidate.name}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">Please Enter A Name.</Form.Control.Feedback>
              </Form.Group>
            </div><div className='screen-styling'>
              <Form.Group controlId="formEmail" style={{ marginBottom: '10px', width: '100%' }} xs={6} md={12}>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter Email*"
                  value={candidate.email}
                  onChange={handleChange}
                  required
                />
                <Form.Control.Feedback type="invalid">Please Enter A Valid Email Address.</Form.Control.Feedback>
              </Form.Group>
            </div>
            <div className='screen-styling'>
              {/* <Form.Group controlId="formJobId" style={{ marginBottom: '10px',width:'100%',marginRight:'8px'  }} >
          <Form.Control
            type="text"
            name="jobId"
            placeholder="Enter Job ID*"
            value={candidate.jobId}
            onChange={handleChange}
            required
            disabled
          />
          <Form.Control.Feedback type="invalid">Please Enter A JobId.</Form.Control.Feedback>
        </Form.Group> */}

              <Form.Group controlId="formPhoneNumber" style={{ marginBottom: '15px', width: '100%' }} >
                <Row>
                  <Col xs={4} style={{ paddingRight: '0px' }}>
                    <Form.Control
                      as="select"
                      name="countryCode"
                      value={candidate.countryCode}
                      onChange={handleChange}
                      required
                      style={{ fontSize: '14px', paddingBottom: '8px' }}
                    >
                      {/* Options for country codes */}
                      <option value="+1">  +1 (USA)</option>
                      <option value="+91">+91 (India)</option>
                      <option value="+52">+52 (Mexico)</option>
                      <option value="+55">+55 (Brazil)</option>
                      {/* Add more country codes as needed */}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">Please Select A Country Code.</Form.Control.Feedback>
                  </Col>
                  <Col xs={8} style={{ paddingLeft: '10px' }}>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      value={candidate.phoneNumber}
                      onChange={numberChange}
                      placeholder="Enter Phone Number"
                      maxLength={10}
                    // required
                    />
                    <Form.Control.Feedback type="invalid">Please Enter Phone Number.</Form.Control.Feedback>
                  </Col>
                </Row>
                {/* <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}> */}
                <div style={{ marginTop: '10px' }} disabled={resumeLoading}>
            <label htmlFor="file-input" className="file-input-label" disabled={resumeLoading}>
                {resumeLoading && <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />}
                {resumeLoading ? 'Uploading Resume' : 'Upload Resume'}
            </label>
            <input
                id="file-input"
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={uploadResume}
                style={{ display: 'none' }}
                multiple
                disabled={resumeLoading}
            />
        </div>
        {/* <div style={{ marginTop: '10px', textAlign: 'center' }}>
    <label
        htmlFor="file-input-bulk"
        className="file-input-label"
        style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            borderRadius: '5px',
            textAlign: 'center',
            cursor: 'pointer',
            fontSize: '16px',
        }}
    >
        <span style={{ fontWeight: 'bold' }}>Upload CSV File</span>
    </label>
    <input
        id="file-input-bulk"
        type="file"
        accept=".csv"
        onChange={handleBulkUpload}
        style={{ display: 'none' }}
    />
</div> */}

        {/* </div> */}
        {/* <div style={{display:'flex', alignItems:'flex-end', textAlign:'end', justifyContent:'flex-end',}}>
        <div style={{ marginTop: '15px', textAlign: 'left', fontSize: '14px', }}>
        <p style={{ fontWeight: '500', marginBottom: '5px' }}>For Bulk Registration Ensure your CSV file has the following headers:</p>
        <p style={{ margin: '0' }}></p>
        <ul style={{ paddingLeft: '20px', margin: '10px 0' }}>
            <li><strong>candidate_name</strong></li>
            <li><strong>candidate_email</strong></li>
            <li><strong>candidate_phone_no</strong></li>
            <li><strong>candidate_country_code</strong></li>
        </ul>
    </div>
    </div> */}
                
              </Form.Group>
              
            </div>
            <></>

            {loading && (
              <div className="spinner-overlay">
                <Spinner animation="border" role="status">
                  <span className="sr-only"></span>
                </Spinner>
              </div>
            )}
            <Button type="submit" variant="dark" className="Button"  disabled={!showSubmit && fileStatus==1}>Submit</Button>

          </Form>
          </Tab>
          <Tab eventKey="add-bulk-candidates"
          title={<span style={{ color: activeTab === 'add-bulk-candidates' ? '#007bff' : '#000' }}>Add Bulk Candidates</span>}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            {/* <div className='screen-styling'> */}
              {/* <Form.Group controlId="formName" style={{ marginBottom: '10px', marginRight: '0px', width: '100%' }} >
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter Name*"
                  value={candidate.name}
                  onChange={handleChange}
                  // required
                />
                <Form.Control.Feedback type="invalid">Please Enter A Name.</Form.Control.Feedback>
              </Form.Group> */}
            {/* </div> */}
            {/* <div className='screen-styling'>
              <Form.Group controlId="formEmail" style={{ marginBottom: '10px', width: '100%' }} xs={6} md={12}>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder="Enter Email*"
                  value={candidate.email}
                  onChange={handleChange}
                  // required
                />
                <Form.Control.Feedback type="invalid">Please Enter A Valid Email Address.</Form.Control.Feedback>
              </Form.Group>
            </div> */}
            <div className='screen-styling'>
              {/* <Form.Group controlId="formJobId" style={{ marginBottom: '10px',width:'100%',marginRight:'8px'  }} >
          <Form.Control
            type="text"
            name="jobId"
            placeholder="Enter Job ID*"
            value={candidate.jobId}
            onChange={handleChange}
            required
            disabled
          />
          <Form.Control.Feedback type="invalid">Please Enter A JobId.</Form.Control.Feedback>
        </Form.Group> */}

              {/* <Form.Group controlId="formPhoneNumber" style={{ marginBottom: '15px', width: '100%' }} > */}
                {/* <Row> */}
                  {/* <Col xs={4} style={{ paddingRight: '0px' }}> */}
                    {/* <Form.Control
                      as="select"
                      name="countryCode"
                      value={candidate.countryCode}
                      onChange={handleChange}
                      required
                      style={{ fontSize: '14px', paddingBottom: '8px' }}
                    >
        
                      <option value="+1">  +1 (USA)</option>
                      <option value="+91">+91 (India)</option>
                      <option value="+52">+52 (Mexico)</option>
                      <option value="+55">+55 (Brazil)</option>

                    </Form.Control> */}
                    {/* <Form.Control.Feedback type="invalid">Please Select A Country Code.</Form.Control.Feedback> */}
                  {/* </Col> */}
                  {/* <Col xs={8} style={{ paddingLeft: '10px' }}>
                    <Form.Control
                      type="text"
                      name="phoneNumber"
                      value={candidate.phoneNumber}
                      onChange={numberChange}
                      placeholder="Enter Phone Number"
                      maxLength={10}
  
                    />
                    <Form.Control.Feedback type="invalid">Please Enter Phone Number.</Form.Control.Feedback>
                  </Col> */}
                {/* </Row> */}
                <div>
                {/* <div > */}
                {/* <div style={{ marginTop: '10px' }} disabled={resumeLoading}>
            <label htmlFor="file-input" className="file-input-label" disabled={resumeLoading}>
                {resumeLoading && <Spinner animation="border" size="sm" role="status" style={{ marginRight: '5px' }} />}
                {resumeLoading ? 'Uploading Resume' : 'Upload Resume'}
            </label>
            <input
                id="file-input"
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={uploadResume}
                style={{ display: 'none' }}
                multiple
                disabled={resumeLoading}
            />
        </div> */}
        <div style={{ marginTop: '10px', textAlign:'center',justifyContent:'center' }}>
    <label
        htmlFor="file-input-bulk"
        className="file-input-label"
        style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '8px 10px',
            backgroundColor: 'black',
            color: '#fff',
            borderRadius: '5px',
            textAlign: 'center',
            cursor: 'pointer',
            fontSize: '14px',
        }}
    >
        <span style={{ fontWeight: 'bold' }}>Upload CSV File</span>
    </label>
    <input
        id="file-input-bulk"
        type="file"
        accept=".csv"
        onChange={handleBulkUpload}
        style={{ display: 'none' }}
    />
    <div
    style={{
      marginTop: '10px',
      fontSize: '14px',
      color: '#333',
      minHeight: '20px', // Reserve space even when no file is uploaded
    }}
  >
    {fileName && (
      <span>
        <span style={{ fontWeight: 'bold' }}>Uploaded File:</span> {fileName}
      </span>
    )}
  </div>
</div>

        {/* </div> */}
        <div style={{ marginTop: '8px',  fontSize: '13px', display:'flex', flexDirection:'column', justifyContent:'center' }}>
        <p style={{ fontWeight: '500', marginBottom: '3px' }}>For bulk registration ensure your CSV file has the following headers:</p>
        {/* <p style={{ margin: '0' }}></p> */}
        <ul style={{ paddingLeft: '20px', margin: '5px 0' }}>
            <li><strong style={{color:'#5691fc'}}>candidate_name</strong></li>
            <li><strong style={{color:'#5691fc'}}>candidate_email</strong></li>
            <li><strong style={{color:'#5691fc'}}>candidate_phone_no</strong></li>
            <li><strong style={{color:'#5691fc'}}>candidate_country_code</strong></li>
        </ul>
    </div>

    </div>
                
              {/* </Form.Group> */}
              
            </div>
            <></>

            {loading && (
              <div className="spinner-overlay">
                <Spinner animation="border" role="status">
                  <span className="sr-only"></span>
                </Spinner>
              </div>
            )}
            <Button type="submit" variant="dark" className="Button"  disabled={!showSubmit && fileStatus==1}>Submit</Button>

          </Form>
          </Tab>
      </Tabs>
          {/* {sucmsg && (
            <div style={{ marginTop: '8px' }}> <span className='info-title'>Exam Link:</span> <span className='info-data'> {examLink}</span> {examLink && <span> <Button variant="dark" className="copy-button" onClick={handleCopy}>
              {buttonText}
            </Button></span>}  </div>
          )} */}
          {examLink && (<div style={{marginTop:'15px'}}>
            <legend className="scheduler-border-ing">
                    <div className="" style={{ backgroundColor: '#fff', fontSize: '13px', fontWeight: '400', paddingLeft: '5px' }}>Exam Link:</div>
                  </legend>
            <Form.Group style={{ width: '100%' }}>
              <Form.Control
                value={examLink}
                aria-label="Generated Link"
                aria-describedby="generated-link"
                readOnly
                style={{ background: 'white' }}
              />
            </Form.Group>
          </div>)}
          <div style={{marginTop:'5px'}}>
            <Row>
              <div className='col-12 col-md-6' style={{marginBottom:'5px'}}>
                {examLink && (
                  <Button variant="dark" className="copy-button" onClick={handleCopy} style={{width:'100%'}}>
                    {buttonText}
                  </Button>)}

              </div>
              <div className='col-12 col-md-6' style={{marginBottom:'5px'}}>
                {candidateButtonFlag && (

                  <Button onClick={clickCandidatePage} className="Button-add" style={{ backgroundColor: 'black', marginBottom: '10px',width:'100%' }}>Go to Candidate Page</Button>
                )}

              </div>
            </Row>
          </div>
        </div>
        {/* <div style={{paddingBottom:'25px'}}>
      {showJobTextArea &&(
        <div  className='jobdesc-div'>
          <Row style={{margin:'0px'}}>
            <div className='info-title' style={{display:'flex',justifyContent:'center',paddingBottom:'10px',color:'#000'}}>Java Description Examples</div>
          </Row>
      
        <Row>
          <div ><span className='info-title'>Java FullStack:</span><span className='info-data' style={{paddingLeft:'10px'}}>Java,SpringBoot,HTML,CSS,JavaScript,ReactNAtive</span></div>
          <div ><span className='info-title'>FrontEnd UI Developer:</span><span className='info-data'style={{paddingLeft:'10px'}}>HTML,CSS,JavaScript,Bootstrap,ReactJS</span></div>
          <div ><span className='info-title'>MicroProcessor:</span><span className='info-data' style={{paddingLeft:'10px'}}>MicroProcessor and Micro Controller,Electonic devices,Electric and Electonic Networks</span></div>
          <div ><span className='info-title'>backend Developer:</span><span className='info-data' style={{paddingLeft:'10px'}}>Python,Java,DynamoDB,MangoDB</span></div>
          <div ><span className='info-title'>System Admin:</span><span className='info-data' style={{paddingLeft:'10px'}}>Microsoft,Excel,Typing,Shortcut keys in Excel</span></div>
        </Row>

      </div>
      
      )}
      </div> */}
      </div>
    </div>
  );
};

export default CandidateDetails;